import DropdownControl from "./DropdownControl.vue";
import { pluginify } from "./../../util";
export default pluginify(DropdownControl);
export { DropdownControl };
